import { createStore } from "vuex";

import router from "@/router";
import roleIds, { roleNamePatterns } from "@/config/roles";
let localeUinfo = localStorage.getItem("userInfo") || null;
let localePermission = localStorage.getItem("localePermission") || [];
let userInfo = {};
if (localeUinfo) {
  userInfo = JSON.parse(localeUinfo);
}
if (localePermission && localePermission.length > 0) {
  localePermission = JSON.parse(localePermission);
}

export default createStore({
  state: {
    userInfo: userInfo,
    isLoading: false,
    permissionList: localePermission,
    isBigWin: true,
    currentClient: null,
    currentOrder: null,
    systemBreak: null,
    classifier_menus: [
      {
        label: "l_Deferred_payment_conditions",
        router: "PaymentTerms",
      },
      { label: "l_Banks", router: "BankView", roles: ["isProductHead"] },
      { label: "l_Breaking_rule", router: "BreakingRule" },
      { label: "l_Carrier_types", router: "CarrierType" },
      { label: "l_Client_types", router: "ClientType" },
      { label: "l_Countries", router: "CountryView" },
      { label: "l_Cities", router: "CityView" },
      { label: "l_Cargo_statuses", router: "CargoStatus" },
      { label: "l_Transport_types", router: "CustomTransportTypes" },
      { label: "l_VAT_rates", router: "VatRates" },
      {
        label: "l_Position_of_contact_persons",
        router: "PositionOfContactPersons",
      },
      { label: "l_Product", router: "ProductTypes" },
      { label: "l_Workers_post", router: "WorkersPost" },
      // { label: "l_Document_statuses" },
      { label: "l_Trip_statuses", router: "TripStatus" },
      { label: "l_Request_statuses", router: "RequestStatuses" },
      { label: "l_Packagings", router: "PackagingsView" },
      { label: "l_Order_statuses", router: "OrderStatuses" },
      { label: "l_Request_purposes", router: "ReqPurposes" },
      { label: "l_Rail_stations", router: "RailStations" },
      { label: "l_Request_sources", router: "ReqSources" },
      { label: "l_The_reason_of_refusal", router: "RefusalReason" },
      { label: "l_Auto_pick_up", router: "AutoPickUp" },
      { label: "l_Feedback_reasons", router: "FeedbackReasons" },
      { label: "l_Product_guides", router: "ProductGuideContent" },
    ],
    system_break_menu: [
      { label: "l_System_break", router: "SystemBreakManage" },
    ],
    organization_menu: [
      { label: "l_Companies", router: "OrganizationCompanies" },
      { label: "l_Departments", router: "DepartmentsView" },
      { label: "l_Employees", router: "EmployeesView" },
      { label: "l_Group_of_employees", router: "GroupOfEmployees" },
    ],
    log_menu: [{ label: "l_Session_log", router: "ActionsView" }],
    exchange_rate_menu: [
      { label: "l_Usd_kzt_rate", router: "ManualExchangeRates" },
      { label: "l_Forte_rates", router: "ForteExchangeRates" },
    ],
    template_menus: [
      // roles — геттеры ролей, которым виден пункт. isAdmin виден всегда.
      { label: "l_Expense_templates", router: "ExpenseTemplate", roles: [] },
      {
        label: "Шаблоны себестоимости",
        router: "AdditionalExpenseTemplate",
        roles: [],
      },
      {
        label: "l_Manager_assignment_templates",
        router: "ManagerAssignmentTemplates",
        roles: ["isSalesHead", "isLogist"],
      },
      {
        label: "l_Product_type_assignment_templates",
        router: "ProductTypeAssignmentTemplates",
        roles: ["isSalesHead", "isLogist"],
      },
      {
        label: "l_Invoice_nomenclatures",
        router: "InvoiceNomenclatures",
        roles: [],
      },
      // {label: "l_Invoices", router: "InvoicesTemplate"},
    ],
  },
  getters: {
    userInfo(state) {
      return state.userInfo;
    },
    getClassifier(state, getters) {
      // Админ и начальник продаж видят все справочники; остальным ролям —
      // только помеченные их геттером.
      if (getters.isAdmin || getters.isSalesHead) return state.classifier_menus;
      return state.classifier_menus.filter((item) =>
        (item.roles || []).some((role) => getters[role])
      );
    },
    getTemplates(state, getters) {
      // Админ видит все шаблоны; остальным ролям — только помеченные их геттером.
      if (getters.isAdmin) return state.template_menus;
      return state.template_menus.filter((item) =>
        (item.roles || []).some((role) => getters[role])
      );
    },
    getOrganization(state) {
      return state.organization_menu;
    },
    getLogs(state) {
      return state.log_menu;
    },
    getExchangeRatesMenu(state) {
      return state.exchange_rate_menu;
    },
    hasLogin(state) {
      return Boolean(Object.keys(state.userInfo).length);
    },
    userId(state) {
      if (Object.keys(state.userInfo).length) {
        if (state.userInfo.adminType) {
          return state.userInfo.adminType.guid;
        } else if (state.userInfo.info) {
          return state.userInfo.info.guid;
        }
        return 0;
      } else {
        return 0;
      }
    },
    isChinaManager(_state, getters) {
      const ids = getters.getRoleIds;
      if (ids?.length) {
        return ids.some((id) => roleIds.chinaManager.includes(id));
      }
      return false;
    },
    isAdmin(_state, getters) {
      const ids = getters.getRoleIds;
      if (ids?.length) {
        return ids.some((id) => roleIds.admin.includes(id));
      }
      return false;
    },
    isLogist(_state, getters) {
      const ids = getters.getRoleIds;
      if (ids?.length) {
        return ids.some((id) => roleIds.logist.includes(id));
      }
      return false;
    },
    isSuperAdmin(store) {
      if (Object.keys(store.userInfo).length > 0) {
        if (
          store.userInfo.adminType &&
          store.userInfo.adminType.isSuper === 1
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    isSalesHead(_state, getters) {
      const ids = getters.getRoleIds;
      if (ids?.length) {
        return ids.some((id) => roleIds.salesHead.includes(id));
      }
      return false;
    },
    isProduct(_state, getters) {
      const ids = getters.getRoleIds;
      if (ids?.length) {
        return ids.some((id) => roleIds.product.includes(id));
      }
      return false;
    },
    isProductHead(_state, getters) {
      const ids = getters.getRoleIds;
      if (ids?.length) {
        return ids.some((id) => roleIds.productHead.includes(id));
      }
      return false;
    },
    isUmit(_state, getters) {
      const ids = getters.getRoleIds;
      if (ids?.length) {
        return ids.some((id) => roleIds.umit.includes(id));
      }
      return false;
    },
    isAccountant(_state, getters) {
      const ids = getters.getRoleIds;
      if (ids?.length) {
        return ids.some((id) => roleIds.accountant.includes(id));
      }
      return false;
    },
    isCustoms(_state, getters) {
      const ids = getters.getRoleIds;
      if (ids?.length && ids.some((id) => roleIds.customs.includes(id))) {
        return true;
      }
      // id группы на стенде может не совпадать с захардкоженным — тогда
      // опознаём таможню по названию группы или отдела пользователя.
      const matches = (value) =>
        Boolean(value) &&
        roleNamePatterns.customs.some((pattern) => pattern.test(value));
      return (
        getters.getRoleNames.some(matches) ||
        matches(getters.getDepartmentName)
      );
    },
    isCustomsHead(_state, getters) {
      const ids = getters.getRoleIds;
      if (ids?.length) {
        return ids.some((id) => roleIds.customsHead.includes(id));
      }
      return false;
    },
    // Таможенный отдел целиком: рядовые сотрудники и начальник отдела.
    isCustomsUser(_state, getters) {
      return Boolean(getters.isCustoms || getters.isCustomsHead);
    },
    // Единая точка правды для доступа к задачам по заказам: используется
    // и в guard роутера, и в меню — чтобы условия не разъезжались.
    canViewOrderTasks(_state, getters) {
      return Boolean(
        getters.isCustoms || getters.isAdmin || getters.isSuperAdmin
      );
    },
    // Планы продаж заводит начальник отдела продаж своим менеджерам.
    // Раздел виден только ему и админам; по умолчанию каждый видит только
    // свои планы — owner проверяет бэкенд.
    canViewSalesPlans(_state, getters) {
      return Boolean(getters.isSalesHead || getters.isAdmin);
    },
    // Планы всех начальников отдела продаж (GET /manager-sales-plans/all)
    // бэкенд отдаёт только роли, которой разрешён просмотр всех планов —
    // у нас это руководство. Остальным эндпоинт вернёт ошибку доступа.
    canViewAllSalesPlans(_state, getters) {
      return Boolean(getters.isAdmin || getters.isSuperAdmin);
    },
    // Удалять задачи по заказам может руководство (админы) и начальник
    // таможенного отдела. На бэке право проверяется как order_task#delete.
    canDeleteOrderTasks(_state, getters) {
      return Boolean(
        getters.isAdmin || getters.isSuperAdmin || getters.isCustomsHead
      );
    },
    isCompliance(_state, getters) {
      return getters.isAccountant || getters.isSuperAdmin || getters.isAdmin;
    },
    getRoleIds(store) {
      return store.userInfo?.userInfo?.roles?.map((role) => role.id);
    },
    getRoleNames(store) {
      return (
        store.userInfo?.userInfo?.roles
          ?.map((role) => role.name)
          .filter(Boolean) || []
      );
    },
    getDepartmentName(store) {
      return store.userInfo?.userInfo?.department?.departmentName || "";
    },
    getCurrentClient(state) {
      return state.currentClient;
    },
    getCurrentOrder(state) {
      return state.currentOrder;
    },
    getSystemBreakMenu(state) {
      return state.system_break_menu;
    },
    activeSystemBreak(state) {
      return state.systemBreak;
    },
  },
  mutations: {
    setUserInfo(state, e) {
      let info = e;
      // console.log(info)
      if (e !== "object") {
        state.userInfo = info;
        localStorage.setItem("userInfo", JSON.stringify(info));
      }
      return null;
    },
    updateUserInfo(state, e) {
      let info = e;
      if (e !== "object") {
        let userInfo = JSON.parse(JSON.stringify(state.userInfo));
        userInfo["info"] = {
          ...userInfo.info,
          ...info,
        };
        state.userInfo = userInfo;
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
      }
      return null;
    },
    setLoading(state, e) {
      state.isLoading = Boolean(e);
    },
    signOut(state) {
      state.userInfo = {};
      localStorage.setItem("userInfo", JSON.stringify({}));
      router.push({ name: "LoginView" });
    },
    setPermissionList(state, info) {
      if (typeof info != "object") {
        console.log("wrong permission format" + info);
        return;
      }
      state.permissionList = JSON.parse(JSON.stringify(info));
      localStorage.setItem("localePermission", JSON.stringify(info));
    },
    setBigWinType(state, info) {
      state.isBigWin = info;
    },
    setCurrentClient(state, clientData) {
      state.currentClient = clientData;
    },
    setCurrentOrder(state, orderData) {
      state.currentOrder = orderData;
    },
    setSystemBreak(state, data) {
      state.systemBreak = data;
    },
  },
  actions: {},
  modules: {},
});
